import { Injectable } from '@angular/core';
import { Menu } from 'src/app/_model/menu';
import { Resetable } from '../../resetter/resetable';

/**
 * DataAccessObject for Menues
 */
@Injectable()
export abstract class MenuDaoService implements Resetable {
  /**
   * Save a menu with a defined name in persitent storage
   * @param menuName the name of the menu
   * @param menu the [[Menu]] object
   */
  public abstract saveMenu(menu: Menu): Promise<void>;

  /**
   * Loads a menu with a given name from the persisten storage
   * @param menuName the name of the menu
   * @returns the loaded [[Menu]] object
   */
  public abstract loadMenu(): Promise<Menu>;

  // Clearable
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
